import { render } from "./CardiovascularDiagnosis.vue?vue&type=template&id=5ff584f8"
import script from "./CardiovascularDiagnosis.vue?vue&type=script&lang=js"
export * from "./CardiovascularDiagnosis.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__